import { RouteConfig } from 'vue-router'
import { suspendedLocationRouteNames } from '@/routes/constants/location'

const SuspendedLocation = () =>
  import(
    /* webpackChunkName: "agency-billing-inactive-location" */ /*'@/pmd/pages/saas/SaasBuilder.vue'*/
    '@/pmd/pages/agency/billing/SuspendedLocationV2.vue'
  ).then(m => m.default)

export const suspendedRoute: RouteConfig[] = [
  {
    path: 'suspended',
    name: suspendedLocationRouteNames.default,
    component: SuspendedLocation,
    meta: {
      hideTopBar: false,
    },
  },
]
